import { APP, HOME, VIEWER, IMAGE, DOWNLOAD, REPORT, PLOT, PLOT_VIEWER } from '../constants';

// App
export const setCurrentPage = (param) => ({
    type: APP.SET_CURRENT_PAGE,
    payload: param
});

export const setJwtoken = (param) => ({
    type: APP.SET_JWTOKEN,
    payload: param
});

export const setPageTopLoader = (param) => ({
    type: APP.SET_PAGE_TOP_LOADER,
    payload: param
});

export const setIdToken = (param) => ({
    type: APP.SET_ID_TOKEN,
    payload: param
});

export const setAccessKey = (param) => ({
    type: APP.SET_ACCESS_KEY,
    payload: param
});

export const setUserName = (param) => ({
    type: APP.SET_USERNAME,
    payload: param
});

export const setUserEmail = (param) => ({
    type: APP.SET_USER_EMAIL,
    payload: param
});

export const setDateRange = (param) => ({
    type: APP.SET_DATE_RANGE,
    payload: param
});

export const setMinMaxDateRange = (param) => ({
    type: APP.SET_MIN_MAX_DATE_RANGE,
    payload: param
});

export const setPeriodType = (param) => ({
    type: APP.SET_PERIOD_TYPE,
    payload: param
});

export const setMissionOnly = (param) => ({
    type: APP.SET_MISSION_ONLY,
    payload: param
});

export const setNoReport = (param) => ({
    type: APP.SET_NO_REPORT,
    payload: param
});

export const getSeasonData = () => ({
    type: APP.GET_SEASON_DATA,
});

export const setSeasonData = (param) => ({
    type: APP.SET_SEASON_DATA,
    payload: param
});

export const setSelectedSeason = (param) => ({
    type: APP.SET_SELECTED_SEASON,
    payload: param
});

export const setSelectedSeasonLabel = (param) => ({
    type: APP.SET_SELECTED_SEASON_LABEL,
    payload: param
});

export const setFilterDrawerState = (param) => ({
    type: APP.SET_FILTER_DRAWER_STATE,
    payload: param
});

export const setFilterType = (param) => ({
    type: APP.SET_FILTER_TYPE,
    payload: param
});

export const setSelectedTag = (param) => ({
    type: APP.SET_SELECTED_TAG,
    payload: param
});

export const setTagSavingLoader = (param) => ({
    type: APP.SET_TAG_SAVING_LOADER,
    payload: param
});

export const setReportStatusSavingLoader = (param) => ({
    type: APP.SET_REPORT_STATUS_SAVING_LOADER,
    payload: param
});

export const getSavedSelectedTagDataByFileName = (param) => ({
    type: APP.GET_SAVED_SELECTED_TAG_DATA_BY_FILENAME,
    payload: param
});

export const getSavedSelectedTagDataByEmail = () => ({
    type: APP.GET_SAVED_SELECTED_TAG_DATA_BY_EMAIL,
});

export const setSavedSelectedTagData = (param) => ({
    type: APP.SET_SAVED_SELECTED_TAG_DATA,
    payload: param
});

export const setSavedSelectedReportTagData = (param) => ({
    type: APP.SET_SAVED_SELECTED_REPORT_TAG_DATA,
    payload: param
});

export const getSavedSelectedReportTagDataByReportId = (param) => ({
    type: APP.GET_SAVED_SELECTED_REPORT_TAG_DATA_BY_REPORT_ID,
    payload: param
});

export const getSavedSelectedReportTagDataBy = (param) => ({
    type: APP.GET_SAVED_SELECTED_REPORT_TAG_DATA_BY,
    payload: param
});

export const setSavedSelectedReportTagDataBy = (param) => ({
    type: APP.SET_SAVED_SELECTED_REPORT_TAG_DATA_BY,
    payload: param
});

export const setDrawerTagTip = (param) => ({
    type: APP.SET_DRAWER_TAG_TIP,
    payload: param
});

export const setCommentSavingLoader = (param) => ({
    type: APP.SET_COMMENT_SAVING_LOADER,
    payload: param
});

export const setAssetComment = (param) => ({
    type: APP.SET_ASSET_COMMENT,
    payload: param
});

export const resetStore = () => ({
    type: APP.RESET_STORE,
});

export const setSavedCommentData = (param) => ({
    type: APP.SET_SAVED_COMMENT_DATA,
    payload: param
});

export const getSavedCommentDataByFileName = (param) => ({
    type: APP.GET_SAVED_COMMENT_DATA_BY_FILENAME,
    payload: param
});

// Report Tag
export const setSelectedReportTag = (param) => ({
    type: APP.SET_SELECTED_REPORT_TAG,
    payload: param
});

// Report Status
export const setSelectedReportStatus = (param) => ({
    type: APP.SET_SELECTED_REPORT_STATUS,
    payload: param
});

export const setSavedSelectedReportStatusData = (param) => ({
    type: APP.SET_SAVED_SELECTED_REPORT_STATUS_DATA,
    payload: param
});

// Plot
export const getPlotData = (param) => ({
    type: PLOT.GET_PLOT_DATA,
    payload: param
});

export const setPlotData = (param) => ({
    type: PLOT.SET_PLOT_DATA,
    payload: param
});

export const setPlotSummary = (param) => ({
    type: PLOT.SET_PLOT_SUMMARY,
    payload: param
});

export const setPlotLoading = (param) => ({
    type: PLOT.SET_PLOT_LOADING,
    payload: param
});

export const setPlotError = (param) => ({
    type: PLOT.SET_PLOT_ERROR,
    payload: param
});

// Plot Viewer
export const getPlotImageDataByFileName = (param) => ({
    type: PLOT_VIEWER.GET_PLOT_IMAGE_DATA_BY_FILENAME,
    payload: param
});

export const setPlotImageDataByFileName = (param) => ({
    type: PLOT_VIEWER.SET_PLOT_IMAGE_DATA_BY_FILENAME,
    payload: param
});

export const setPlotViewerImageData = (param) => ({
    type: PLOT_VIEWER.SET_PLOT_VIEWER_IMAGE_DATA,
    payload: param
});

export const setPlotViewerLoading = (param) => ({
    type: PLOT_VIEWER.SET_PLOT_VIEWER_LOADING,
    payload: param
});

export const setPlotViewerError = (param) => ({
    type: PLOT_VIEWER.SET_PLOT_VIEWER_ERROR,
    payload: param
});

export const getSavedSelectedReportStatusDataByReportId = (param) => ({
    type: APP.GET_SAVED_SELECTED_REPORT_STATUS_DATA_BY_REPORT_ID,
    payload: param
});

// Mission
export const getMissionData = (param) => ({
    type: APP.GET_MISSION_DATA,
    payload: param
});

export const setMissionData = (param) => ({
    type: APP.SET_MISSION_DATA,
    payload: param
});

export const setSelectedMission = (param) => ({
    type: APP.SET_SELECTED_MISSION,
    payload: param
});

export const setSelectedMissionLabel = (param) => ({
    type: APP.SET_SELECTED_MISSION_LABEL,
    payload: param
});

// HOME
export const getHomeTotalStatsData = () => ({
    type: HOME.GET_TOTAL_STATS_DATA,
});

export const setHomeTotalStatsData = (param) => ({
    type: HOME.SET_TOTAL_STATS_DATA,
    payload: param
});

export const getHomeImageData = (param) => ({
    type: HOME.GET_HOME_IMAGE_DATA,
    payload: param
});

export const setHomeImageData = (param) => ({
    type: HOME.SET_HOME_IMAGE_DATA,
    payload: param
});


export const getHomeMissionImageData = (param) => ({
    type: HOME.GET_HOME_MISSION_IMAGE_DATA,
    payload: param
});

export const setHomeMissionImageData = (param) => ({
    type: HOME.SET_HOME_MISSION_IMAGE_DATA,
    payload: param
});


export const setTotalImageCount =  (param) => ({
    type: HOME.SET_TOTAL_IMAGE_COUNT,
    payload: param
});

export const setCurrentPageNumber =  (param) => ({
    type: HOME.SET_CURRENT_PAGE_NUMBER,
    payload: param
});

export const setFilteredTotal = (param) => ({
    type: HOME.SET_FILTERED_TOTAL,
    payload: param
});

export const setFilter = (param) => ({
    type: HOME.SET_FILTER,
    payload: param
});

// VIEWER
export const getImageDataByFileName = (param) => ({
    type: VIEWER.GET_IMAGE_DATA_BY_FILENAME,
    payload: param
});

export const setImageDataByFileName = (param) => ({
    type: VIEWER.SET_IMAGE_DATA_BY_FILENAME,
    payload: param
});

export const setViewerImageData = (param) => ({
    type: VIEWER.SET_VIEWER_IMAGE_DATA,
    payload: param
});

export const setViewerImageDataExtra = (param) => ({
    type: VIEWER.SET_VIEWER_IMAGE_DATA_EXTRA,
    payload: param
});

// IMAGE
export const getAllImageDataByFileName = (param) => ({
    type: IMAGE.GET_ALL_IMAGE_DATA_BY_FILENAME,
    payload: param
});

export const setAllImageDataByFileName = (param) => ({
    type: IMAGE.SET_ALL_IMAGE_DATA_BY_FILENAME,
    payload: param
});

// REPORT
export const getReportTotalStatsData = () => ({
    type: REPORT.GET_REPORT_TOTAL_STATS_DATA,
});

export const setReportTotalStatsData = (param) => ({
    type: REPORT.SET_REPORT_TOTAL_STATS_DATA,
    payload: param
});

export const getReportData = (param) => ({
    type: REPORT.GET_REPORT_DATA,
    payload: param
});

export const setReportData = (param) => ({
    type: REPORT.SET_REPORT_DATA,
    payload: param
});

export const setReportTagFilterData = (param) => ({
    type: REPORT.SET_REPORT_TAG_FILTER_DATA,
    payload: param
});

export const setReportTotalImageCount = (param) => ({
    type: REPORT.SET_REPORT_TOTAL_IMAGE_COUNT,
    payload: param
});

export const setReportCurrentPageNumber = (param) => ({
    type: REPORT.SET_REPORT_CURRENT_PAGE_NUMBER,
    payload: param
});

export const setReportFilteredTotal = (param) => ({
    type: REPORT.SET_REPORT_FILTERED_TOTAL,
    payload: param
});

export const setReportFilter = (param) => ({
    type: REPORT.SET_REPORT_FILTER,
    payload: param
});

export const setCommonReportFilterOptions = (param) => ({
    type: REPORT.SET_COMMON_REPORT_FILTER_OPTIONS,
    payload: param
});

export const getDownloadReportData = (param) => ({
    type: REPORT.GET_DOWNLOAD_REPORT_DATA,
    payload: param,
});

export const getRemovalRequestDownloadData = (param) => ({
    type: REPORT.GET_REMOVAL_REQUEST_DOWNLOAD_DATA,
    payload: param,
});

export const getBirdNestRewardDownloadData = (param) => ({
    type: REPORT.GET_BIRDNEST_REWARD_DOWNLOAD_DATA,
    payload: param,
});

export const setDownloadReportData = (param) => ({
    type: REPORT.SET_DOWNLOAD_REPORT_DATA,
    payload: param,
});

export const getDownloadReportDataNtt = (param) => ({
    type: REPORT.GET_DOWNLOAD_REPORT_DATA_NTT,
    payload: param,
});

export const setDownloadReportDataNtt = (param) => ({
    type: REPORT.SET_DOWNLOAD_REPORT_DATA_NTT,
    payload: param,
});

export const getDownloadReportDataHokuden = (param) => ({
    type: REPORT.GET_DOWNLOAD_REPORT_DATA_HOKUDEN,
    payload: param,
});

export const setDownloadReportDataHokuden = (param) => ({
    type: REPORT.SET_DOWNLOAD_REPORT_DATA_HOKUDEN,
    payload: param,
});

export const getImageDataByReportId = (param) => ({
    type: REPORT.GET_IMAGE_DATA_BY_REPORT_ID,
    payload: param
});

export const setImageDataByReportId = (param) => ({
    type: REPORT.SET_IMAGE_DATA_BY_REPORT_ID,
    payload: param
});

export const setImageDataByOtherUsers = (param) => ({
    type: REPORT.SET_IMAGE_DATA_BY_OTHER_USERS,
    payload: param
});

export const setNoImageDataByReportId = (param) => ({
    type: REPORT.SET_NO_IMAGE_DATA_BY_REPORT_ID,
    payload: param
});

// NTT
export const setSavedSelectedTagDataNtt = (param) => ({
    type: APP.SET_SAVED_SELECTED_TAG_DATA_NTT,
    payload: param
});

export const setSelectedTagNtt = (param) => ({
    type: APP.SET_SELECTED_TAG_NTT,
    payload: param
});

export const getSavedSelectedTagDataByFileNameNtt = (param) => ({
    type: APP.GET_SAVED_SELECTED_TAG_DATA_BY_FILENAME_NTT,
    payload: param
});

export const getHomeImageDataNtt = (param) => ({
    type: HOME.GET_HOME_IMAGE_DATA_NTT,
    payload: param
});

export const setHomeImageDataNtt = (param) => ({
    type: HOME.SET_HOME_IMAGE_DATA_NTT,
    payload: param
});

export const setFilterNtt = (param) => ({
    type: HOME.SET_FILTER_NTT,
    payload: param
});

export const setReportFilterNtt = (param) => ({
    type: REPORT.SET_REPORT_FILTER_NTT,
    payload: param
});

export const getReportDataNtt = (param) => ({
    type: REPORT.GET_REPORT_DATA_NTT,
    payload: param
});

export const setReportDataNtt = (param) => ({
    type: REPORT.SET_REPORT_DATA_NTT,
    payload: param
});

export const setReportTagFilterDataNtt = (param) => ({
    type: REPORT.SET_REPORT_TAG_FILTER_DATA_NTT,
    payload: param
});

// HOKUDEN
export const setSavedSelectedTagDataHokuden = (param) => ({
    type: APP.SET_SAVED_SELECTED_TAG_DATA_HOKUDEN,
    payload: param
});

export const setSelectedTagHokuden = (param) => ({
    type: APP.SET_SELECTED_TAG_HOKUDEN,
    payload: param
});

export const getHomeImageDataHokuden = (param) => ({
    type: HOME.GET_HOME_IMAGE_DATA_HOKUDEN,
    payload: param
});

export const setHomeImageDataHokuden = (param) => ({
    type: HOME.SET_HOME_IMAGE_DATA_HOKUDEN,
    payload: param
});

export const setFilterHokuden = (param) => ({
    type: HOME.SET_FILTER_HOKUDEN,
    payload: param
});

export const setReportFilterHokuden = (param) => ({
    type: REPORT.SET_REPORT_FILTER_HOKUDEN,
    payload: param
});

export const getReportDataHokuden = (param) => ({
    type: REPORT.GET_REPORT_DATA_HOKUDEN,
    payload: param
});

export const setReportDataHokuden = (param) => ({
    type: REPORT.SET_REPORT_DATA_HOKUDEN,
    payload: param
});

export const setReportTagFilterDataHokuden = (param) => ({
    type: REPORT.SET_REPORT_TAG_FILTER_DATA_HOKUDEN,
    payload: param
});

export const setHokudenOptionCity = (param) => ({
    type: HOME.SET_HOKUDEN_OPTION_CITY,
    payload: param
});

export const setHokudenOptionBranch = (param) => ({
    type: HOME.SET_HOKUDEN_OPTION_BRANCH,
    payload: param
});

export const setHokudenReportOptionCity = (param) => ({
    type: REPORT.SET_HOKUDEN_REPORT_OPTION_CITY,
    payload: param
});

export const setHokudenReportOptionBranch = (param) => ({
    type: REPORT.SET_HOKUDEN_REPORT_OPTION_BRANCH,
    payload: param
});

export const setSavedCommentDataHokuden = (param) => ({
    type: APP.SET_SAVED_COMMENT_DATA_HOKUDEN,
    payload: param
});

export const getSavedCommentDataByFileNameHokuden = (param) => ({
    type: APP.GET_SAVED_COMMENT_DATA_BY_FILENAME_HOKUDEN,
    payload: param
});

// Mission Report
export const getReportDataMission = (param) => ({
    type: REPORT.GET_REPORT_DATA_MISSION,
    payload: param
});

export const setReportDataMission = (param) => ({
    type: REPORT.SET_REPORT_DATA_MISSION,
    payload: param
});

export const setReportTagFilterDataMission = (param) => ({
    type: REPORT.SET_REPORT_TAG_FILTER_DATA_MISSION,
    payload: param
});

// DOWNLOAD
export const setTotalFiles = (param) => ({
    type: DOWNLOAD.SET_TOTATL_FILES,
    payload: param
});

export const setAreaGroup = (param) => ({
    type: DOWNLOAD.SET_AREA_GROUP,
    payload: param
});

export const setFilterDownload = (param) => ({
    type: DOWNLOAD.SET_FILTER_DOWNLOAD,
    payload: param
});
